// useful tools constants

export enum DOWNPAYMENT_FLAG_OPTIONS {
  yes = "Yes",
  no = "No"
}